import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import {
  planListAPI,
  addNewPlan,
  editPlanAPI,
  editPlan,
  deletePlan,
  getCategories,
} from "../../api/plan";
import NewPlan from "./NewPlan";
import EditPlan from "./EditPlan";
import useAccess from "../../api/useAccess";
import { downloadCSV } from "../../../helpers/dataTableHelper";

const PlanLists = () => {
  const [addCard, setAddCard] = useState(false);
  const [plans, setPlans] = useState([]);
  const [categories, setCategoties] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const { fetchAccess } = useAccess();
  const permission = fetchAccess();
  //const [loading, setLoading] = useState(false);

  const [loading, setloading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [reqParams, setReqParams] = useState({
    page: currentPage,
    limit: perPage,
    sort_by: "id",
    sort_direction: "DESC",
    category_id: "",
  });
  const [fetch, setFetch] = useState(true);

  const fetchCategory = useCallback(async () => {
    let cats = await getCategories();
    setCategoties(cats);
  }, []);

  const columns = useMemo(
    () => [
      {
        name: "Id",
        selector: (row,index) => index+1,
        wrap: true,
        width: "100px",
        sortable: true,
        sortField: "id",
      },
      {
        name: "Plan Name",
        selector: (row) => row.plan_name,
        width: "130px",
        wrap: true,
        sortable: true,
        sortField: "plan_name",
      },
      {
        name: "Category Name",
        selector: (row) => row.category_name,
        width: "145px",
        wrap: true,
        sortable: true,
        sortField: "category_id",
      },
      {
        name: "Plan Price",
        selector: (row) => row.plan_price,
        wrap: true,
        sortable: true,
        sortField: "plan_price",
      },
      {
        name: "Validity",
        selector: (row) => row.plan_days,
        wrap: true,
        sortable: true,
        sortField: "plan_days",
      },
      {
        name: "Job Limit",
        selector: (row) => row.jobs_limit,
        wrap: true,
        sortable: true,
        sortField: "jobs_limit",
      },
      {
        name: "Total Quota",
        selector: (row) => row.total_unlock_quota,
        width: "120px",
        sortable: true,
        wrap: true,
        sortField: "total_unlock_quota",
      },
      {
        name: "general Quota",
        selector: (row) => row.general_unlock_quota,
        width: "140px",
        wrap: true,
        sortable: true,
        sortField: "general_unlock_quota",
      },
      {
        name: "Applicants Quota",
        selector: (row) => row.applicants_unlock_quota,
        width: "160px",
        wrap: true,
        sortable: true,
        sortField: "applicants_unlock_quota",
      },
      {
        name: "Status",
        selector: (row) => (
          <span
            className={`badge badge-lg light badge-${
              row.published == "1" ? "success" : "danger"
            }`}
          >
            {row.published == "1" ? "Active" : "InActive"}
          </span>
        ),
        wrap: true,
        sortable: true,
        sortField: "published",
      },
      {
        name: "Action",
        width: "150px",
        cell: (row) => (
          <>
            {permission.e === true ? (
              <Link
                to={"#"}
                className="btn btn-sm btn-secondary light"
                onClick={(event) => handleEditClick(event, row)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  className="svg-main-icon"
                >
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z"
                      fill="#000000"
                      fillRule="nonzero"
                      transform="translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409) "
                    ></path>
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="5"
                      y="20"
                      width="15"
                      height="2"
                      rx="1"
                    ></rect>
                  </g>
                </svg>
              </Link>
            ) : (
              <></>
            )}

            {permission.d === true && !row.is_assigned ? (
              <>
                <Link
                  to={"#"}
                  className="btn btn-sm btn-danger light ms-2"
                  onClick={() => handleDeleteClick(row.id)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                    className="svg-main-icon"
                  >
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24"></rect>
                      <path
                        d="M6,8 L6,20.5 C6,21.3284271 6.67157288,22 7.5,22 L16.5,22 C17.3284271,22 18,21.3284271 18,20.5 L18,8 L6,8 Z"
                        fill="#000000"
                        fillRule="nonzero"
                      ></path>
                      <path
                        d="M14,4.5 L14,4 C14,3.44771525 13.5522847,3 13,3 L11,3 C10.4477153,3 10,3.44771525 10,4 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z"
                        fill="#000000"
                        opacity="0.3"
                      ></path>
                    </g>
                  </svg>
                </Link>
              </>
            ) : (
              <></>
            )}
          </>
        ),
      },
    ],
    [permission]
  );

  const fetchUsers = useCallback(
    (params) => {
      setloading(true);
      const queryString = new URLSearchParams(params).toString();
      planListAPI(queryString)
        .then((res) => {
          setPlans(res?.data?.data);
          setTotalRows(res?.data?.total);
          setloading(false);
          setFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          setloading(false);
          setFetch(false);
        });
    },
    [setFetch]
  );

  useEffect(() => {
    if (fetch) {
      fetchUsers(reqParams);
    }
  }, [fetch, reqParams, fetchUsers]);

  useEffect(() => {
    fetchCategory();
  }, []);

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "ascending" ? "▲" : "▼";
    }
    return "↕";
  };

  // delete data
  const handleDeleteClick = async (contactId) => {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Are you sure that you want to delete this record?",
      icon: "warning",
      dangerMode: true,
      buttons: true,
    });

    if (willDelete) {
      await deletePlan(contactId);
      setFetch(true);
      //dataFetch();
      swal("Deleted!", "Record has been deleted!", "success");
    }
  };

  const formState = {
    catid: "",
    cat_name: "",
    plan_name: "",
    plan_days: "",
    plan_price: "",
    currency_code: "INR",
    total_unlock_quota: "",
    general_unlock_quota: "",
    applicants_unlock_quota: "",
    jobs_limit: "",
    sub_recruiter_limit: "",
    created_by: "",
    published: "1",
  };

  //Add data
  const [addFormData, setAddFormData] = useState(formState);

  const handleAddFormChange = (event) => {
    event.preventDefault();
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    const newFormData = { ...addFormData };
    newFormData[fieldName] = fieldValue;

    if (
      fieldName === "general_unlock_quota" ||
      fieldName === "applicants_unlock_quota"
    ) {
      newFormData["total_unlock_quota"] =
        Number(newFormData["general_unlock_quota"]) +
        Number(newFormData["applicants_unlock_quota"]);
    }

    setAddFormData(newFormData);
  };

  const handleAddFormSubmit = async (event) => {
    event.preventDefault();
    var error = false;
    var errorMsg = "";
    if (addFormData.catid === "") {
      error = true;
      errorMsg = "Please select category";
    } else if (addFormData.catid === "" && addFormData.cat_name === "") {
      error = true;
      errorMsg = "Please enter category name";
    } else if (addFormData.plan_name === "") {
      error = true;
      errorMsg = "Please fill Plan Name";
    } else if (addFormData.plan_days === "") {
      error = true;
      errorMsg = "Please fill Plan Validity";
    } else if (addFormData.plan_price === "") {
      error = true;
      errorMsg = "Please fill Plan price";
    } else if (addFormData.jobs_limit === "") {
      error = true;
      errorMsg = "Please fill Job Limit";
    } else if (addFormData.sub_recruiter_limit === "") {
      error = true;
      errorMsg = "Please fill Sub Recruiter Limit";
    } else if (addFormData.general_unlock_quota === "") {
      error = true;
      errorMsg = "Please fill General Unlock Quota";
    } else if (addFormData.applicants_unlock_quota === "") {
      error = true;
      errorMsg = "Please fill Applicants Unlock Quota";
    }
    if (!error) {
      const newContact = {
        catid: addFormData.catid === "c" ? "" : addFormData.catid,
        cat_name: addFormData.cat_name,
        plan_name: addFormData.plan_name,
        plan_days: addFormData.plan_days,
        plan_price: addFormData.plan_price,
        currency_code: addFormData.currency_code,
        total_unlock_quota: addFormData.total_unlock_quota,
        general_unlock_quota: addFormData.general_unlock_quota,
        applicants_unlock_quota: addFormData.applicants_unlock_quota,
        jobs_limit: addFormData.jobs_limit,
        sub_recruiter_limit: addFormData.sub_recruiter_limit,
        created_by: 1,
        status: addFormData.published,
      };
      await addNewPlan(newContact);
      //dataFetch();
      setFetch(true);
      fetchCategory();
      setAddCard(false);
      setAddFormData(formState);
      swal("Successfully Added Plan!", "Successfully Added", "success");
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  const [editModal, setEditModal] = useState(false);
  const [editContactId, setEditContactId] = useState(null);
  const fetchEditData = async (id) => {
    return await editPlanAPI(id);
  };

  const handleEditClick = async (event, contact) => {
    event.preventDefault();
    setEditContactId(contact.id);
    let formValues = await fetchEditData(contact.id);
    formValues["total_unlock_quota"] =
      Number(formValues["general_unlock_quota"]) +
      Number(formValues["applicants_unlock_quota"]);
    formValues["catid"] = formValues["category_id"];
    formValues["cat_name"] = "";
    setEditFormData(formValues);
    setEditModal(true);
  };

  const editFormState = {
    catid: "",
    cat_name: "",
    plan_name: "",
    plan_days: "",
    plan_price: "",
    currency_code: "",
    total_unlock_quota: "",
    general_unlock_quota: "",
    applicants_unlock_quota: "",
    jobs_limit: "",
    sub_recruiter_limit: "",
    created_by: "",
    published: "",
  };

  const [editFormData, setEditFormData] = useState(editFormState);

  const handleEditFormChange = (event) => {
    event.preventDefault();
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    const newFormData = { ...editFormData };
    newFormData[fieldName] = fieldValue;

    if (
      fieldName === "general_unlock_quota" ||
      fieldName === "applicants_unlock_quota"
    ) {
      newFormData["total_unlock_quota"] =
        Number(newFormData["general_unlock_quota"]) +
        Number(newFormData["applicants_unlock_quota"]);
    }

    setEditFormData(newFormData);
  };

  const handleEditFormSubmit = async (event) => {
    event.preventDefault();
    var error = false;
    var errorMsg = "";
    if (editFormData.catid === "") {
      error = true;
      errorMsg = "Please select category";
    } else if (editFormData.catid === "" && editFormData.cat_name === "") {
      error = true;
      errorMsg = "Please enter category name";
    } else if (editFormData.plan_name === "") {
      error = true;
      errorMsg = "Please fill Plan Name";
    } else if (editFormData.plan_days === "") {
      error = true;
      errorMsg = "Please fill Plan Validity";
    } else if (editFormData.plan_price === "") {
      error = true;
      errorMsg = "Please fill Plan price";
    } else if (editFormData.jobs_limit === "") {
      error = true;
      errorMsg = "Please fill Job Limit";
    } else if (editFormData.sub_recruiter_limit === "") {
      error = true;
      errorMsg = "Please fill Sub Recruiter Limit";
    } else if (editFormData.general_unlock_quota === "") {
      error = true;
      errorMsg = "Please fill General Unlock Quota";
    } else if (editFormData.applicants_unlock_quota === "") {
      error = true;
      errorMsg = "Please fill Applicants Unlock Quota";
    }

    if (!error) {
      const editedContact = {
        catid: editFormData.catid === "c" ? "" : editFormData.catid,
        cat_name: editFormData.cat_name,
        plan_name: editFormData.plan_name,
        plan_days: editFormData.plan_days,
        plan_price: editFormData.plan_price,
        currency_code: editFormData.currency_code,
        total_unlock_quota: editFormData.total_unlock_quota,
        general_unlock_quota: editFormData.general_unlock_quota,
        applicants_unlock_quota: editFormData.applicants_unlock_quota,
        jobs_limit: editFormData.jobs_limit,
        sub_recruiter_limit: editFormData.sub_recruiter_limit,
        status: editFormData.published,
      };
      await editPlan(editedContact, editContactId);
      //dataFetch();
      setFetch(true);
      setEditContactId(null);
      setEditModal(false);
      swal("Successfully Added Plan!", "Successfully Updated", "success");
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  const OnSelectCategory = useCallback(async (id) => {
    setReqParams((pre) => ({ ...pre, category_id: id }));
    setFetch(true);
  }, []);

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      setReqParams({
        ...reqParams,
        page: page,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setPerPage(newPerPage);
      setReqParams({
        ...reqParams,
        limit: newPerPage,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleSort = useCallback(
    (column, sortDirection) => {
      if (column?.sortField !== undefined) {
        setReqParams({
          ...reqParams,
          sort_by: column.sortField,
          sort_direction: sortDirection,
        });
        setFetch(true);
      }
    },
    [reqParams, setReqParams, setFetch]
  );

  return (
    <>
      <div className="d-flex align-items-center mb-4 flex-wrap">
        <h4 className="fs-20 font-w600  me-auto">{""}</h4>
        <div>
          <select
            className="btn btn-sm btn-info me-2"
            onChange={(e) => OnSelectCategory(e.target.value)}
          >
            <option value="">Select Category</option>
            {categories.map((cat) => (
              <option value={cat.id} key={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
          <button
            onClick={() => downloadCSV(plans, "planlist-")}
            className="btn btn-warning btn-sm me-2"
          >
            <i className="fas fa-file-csv me-1"></i> Export
          </button>
          {permission.a === true ? (
            <>
              <Link
                to={"#"}
                className="btn btn-primary me-3 btn-sm"
                onClick={() => setAddCard(true)}
              >
                <i className="fas fa-plus me-2"></i>Add New Plan
              </Link>
            </>
          ) : (
            <></>
          )}
          <NewPlan
            addCard={addCard}
            setAddCard={setAddCard}
            handleAddFormChange={handleAddFormChange}
            handleAddFormSubmit={handleAddFormSubmit}
            categories={categories}
            addFormData={addFormData}
          />
          <EditPlan
            editModal={editModal}
            setEditModal={setEditModal}
            handleEditFormChange={handleEditFormChange}
            handleEditFormSubmit={handleEditFormSubmit}
            editFormData={editFormData}
            categories={categories}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="table-responsive">
            <DataTable
              columns={columns}
              data={plans}
              progressPending={loading}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              //selectableRows
              persistTableHead
              //clearSelectedRows={toggleCleared}
              //conditionalRowStyles={rowStyle}
              //   onSelectedRowsChange={({ selectedRows }) => {
              //     //console.log(selectedRows)
              //     setSelectedRows(selectedRows);
              //   }}
              onSort={handleSort}
              sortServer
              fixedHeader={true}
              fixedHeaderScrollHeight={"500px"}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default PlanLists;
